import React from "react";
import {t} from "../../../utilities/TranslationUtils";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {AppButton} from "../../../components/form";

interface CopyClientInfoButton {
  id: string,
  secret: string,
  children?: React.ReactNode
}

const CopyClientInfoButton: React.FC<CopyClientInfoButton> = (props) => {
  const textToCopy = () => {
    return `Identifier: ${props.id}, Client secret: ${props.secret}`;
  }
  return(
    <CopyToClipboard
      text={textToCopy()}
    >
      <AppButton
        variant='secondary'
        className='m1-2'
        date-test='client-dialog-copy-button'
      >
        {t('clients.copyClientInfo')}
      </AppButton>
    </CopyToClipboard>
  )
}

export default CopyClientInfoButton;